import { Component, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { LookupService } from '../../services/lookups/lookup.service';
import { Location } from '../../models/user.model';

@Component({
  selector: 'app-post-by-country',
  templateUrl: './post-by-country.component.html',
  styleUrls: ['./post-by-country.component.css']
})
export class PostByCountryComponent implements OnInit {
  @Input() countryList: Location[];
  countryName: string;
  postsFirst: Location[];
  postsSecond: Location[];
  selectedCountry: Location;
  flagURL: string;
  FASUrl: string;
  constructor(private notifier:NotifierService,
    private spinner: NgxSpinnerService,
    private lookupService: LookupService) { }

  ngOnInit(): void {
    
  }

  loadCountry(countryId: number){
    this.lookupService.getChildLocations(countryId)
    .pipe(finalize(()=>this.spinner.hide()))
    .subscribe((posts: Location[]) => {
      this.selectedCountry = this.countryList.find(x => x.id == countryId);
      this.flagURL = "./assets/flags/" + this.selectedCountry.locationCode.toLowerCase() + ".svg";
      if(posts.length > 3){
        this.postsFirst = posts.slice(0,Math.round(posts.length/2));
        this.postsSecond = posts.slice(Math.round(posts.length/2));
      }
      else{
        this.postsFirst = posts;
        this.postsSecond = [];
      }
      this.FASUrl = "https://www.fas.usda.gov/international-offices" + "?id=" + this.selectedCountry.fasCountryCode;
    });
  }
}
